import React from "react";
import {
  Box,
  Typography,
  IconButton,
  Tooltip,
} from "@mui/material";
import { Visibility } from "@mui/icons-material";
import { safeDateFormat } from "qubCommon/helperMethods/dateHelper";
import { showFloat } from "qubCommon/wijmoHelpers/numberMethods";

const PaymentsTable = ({ rows = [], onPreview }) => {
  if (!rows.length) return null;

  return (
    <Box
      sx={{
        border: "1px solid #dcdcdc",
        borderRadius: 1.5,
        overflowX: "auto",
        mt: 2,
      }}
    >
      <Box sx={{ display: "table", width: "100%" }}>
        {/* Header */}
        <Box
          sx={{
            display: "table-row",
            backgroundColor: "grey.100",
            borderBottom: "1px solid #dcdcdc",
          }}
        >
          {[
            "Αρ.",
            "Τύποι Αιτήσεων",
            "Ημερομηνία",
            "Υπογράφων/ουσα Διατάκτης",
            "Πλήθος",
            "Αξία (€)",
            "Προβολή",
          ].map((header, i) => (
            <Box
              key={i}
              sx={{
                display: "table-cell",
                fontWeight: 600,
                px: 2,
                py: 1,
                textAlign:
                  i < 5 ? "left" : "right",
                whiteSpace: "nowrap",
              }}
            >
              {header}
            </Box>
          ))}
        </Box>

        {/* Rows */}
        {rows.map((row, idx) => (
          <Box
            key={row.id}
            sx={{
              display: "table-row",
              backgroundColor: idx % 2 === 0 ? "background.paper" : "grey.50",
              borderBottom:
                idx < rows.length - 1 ? "1px solid #e0e0e0" : "none",
            }}
          >
            {[
              { value: row.decisionNumber, color: "primary.main", weight: 600, align: "left" },
              { value: row.appTypesConcatenated, align: "left" },
              { value: safeDateFormat(row?.decisionDate), align: "left" },
              { value: row.signedBy, align: "left" },
              { value: row.appCount, align: "right" },
              { value: showFloat(row?.totalAmount), align: "right" },
            ].map((cell, i) => (
              <Box
                key={i}
                sx={{
                  display: "table-cell",
                  px: 2,
                  py: 1.2,
                  textAlign: cell.align,
                  fontWeight: cell.weight || 400,
                  color: cell.color || "text.primary",
                  whiteSpace: "nowrap",
                  cursor: i === 0 ? 'pointer' : "default",
                }}
                onClick={i === 0 ? () => onPreview?.(row) : undefined}
              >
                {cell.value}
              </Box>
            ))}

            {/* Preview icon */}
            <Box
              sx={{
                display: "table-cell",
                px: 2,
                py: 1.2,
                textAlign: "right",
              }}
            >
              <Tooltip title="Προβολή Λεπτομερειών">
                <button
                  onClick={() => onPreview?.(row)}
                  className="btn btn-view"
                  aria-label="Προβολή Αίτησης"
                >
                  <Visibility />
                </button>
              </Tooltip>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PaymentsTable;
